import { Action } from '@ngrx/store';
import { User } from '../../types/users.types';

export enum UsersActionTypes {
  Load = '[Users] Load',
  LoadSuccess = '[Users] Load Success',
  LoadFail = '[Users] Load Fail'
}

export class LoadUsers implements Action {
  public readonly type = UsersActionTypes.Load;
}

export class LoadUsersSuccess implements Action {
  public readonly type = UsersActionTypes.LoadSuccess;

  constructor(public payload: User[]) {}
}

export class LoadUsersFail implements Action {
  public readonly type = UsersActionTypes.LoadFail;

  constructor(public payload: string) {}
}

export type UsersActionsUnion = LoadUsers | LoadUsersSuccess | LoadUsersFail;
